export default "__VITE_ASSET__DMKJqppH__"